import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-mist" data-id="element-359" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-360" data-mp="cng1oereb36u">
        <div className="text-center mb-16" data-id="element-361" data-mp="cm52ytct4lml">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-ink" data-id="element-362" data-mp="7p65q1xujyk6">
            THE COMPLETE <span className="text-gold" data-id="element-363" data-mp="3g69f8rk6bs10">6-IN-1</span> WORKPLACE SAFETY{' '}
            <span className="text-forest" data-id="element-364" data-mp="3c3wb27l2s26c">ATLAS</span> SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-365" data-mp="3pv12wni7bq64">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-gold shadow-lg shadow-ink/10' : 'border-line shadow-sm shadow-ink/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-366" data-mp="3l4az3epfbvdj" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-gold text-ink font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-367" data-mp="2o4wpq6c72vms">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-368" data-mp="1vfzh6uxscd78">
                <span className="w-12 h-12 rounded-xl bg-forest text-gold-light font-display font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-369" data-mp="20ekf2npkeksi">
                  0{index + 1}
                </span>
                <div data-id="element-370" data-mp="3fv1d8dv93ys8">
                  <div className="text-gold-dark font-bold text-sm uppercase tracking-wider" data-id="element-371" data-mp="3fu9jl8l7sb4l">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-ink" data-id="element-372" data-mp="1brq2u62nxe5q">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-forest font-semibold mb-6 border-l-4 border-gold pl-4" data-id="element-373" data-mp="1ksei143slkk7">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-374" data-mp="t21dcshkypxr">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-graphite text-sm leading-relaxed" data-id="element-375" data-mp="16tolbpkvxmwd">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-376" data-mp="eb144l90es0k">
                      {volume.questions.map(question => <li key={question} className="text-ink font-semibold text-sm bg-mist border border-line rounded-lg px-3 py-2" data-id="element-377" data-mp="9b6cgfhetyeg">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-ink font-bold text-base bg-gold-soft border-l-4 border-gold rounded-lg px-4 py-3" data-id="element-378" data-mp="2gz961r0swuat">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-graphite text-sm leading-relaxed" data-id="element-379" data-mp="2uqxixwivjmsu">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-380" data-mp="2zrlfexpvgvug">
                <div data-id="element-381" data-mp="1jb8tmyi5ebov">
                  <p className="text-ink font-semibold text-sm mb-3" data-id="element-382" data-mp="1jazd01iztgvu">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-383" data-mp="1oav81b9ppxz9">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-384" data-mp="1usgio5ubz4v1">
                        <CheckCircle2 size={18} className="text-forest shrink-0 mt-0.5" data-id="element-385" data-mp="1ptdawdmyukjd" />
                        <span className="text-graphite text-sm" data-id="element-386" data-mp="2mjcud34nn3gq">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-387" data-mp="2dh3kmfh7ne4e">
                    <p className="text-ink font-semibold text-sm mb-3" data-id="element-388" data-mp="2dglhr001m1ni">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-389" data-mp="122pxjcua72pf">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-390" data-mp="x5zld0llkr9a">
                          <CheckCircle2 size={18} className="text-forest shrink-0 mt-0.5" data-id="element-391" data-mp="n1avqo7akkyi" />
                          <span className="text-graphite text-sm" data-id="element-392" data-mp="rzufqj2brmo8">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-393" data-mp="15qhci5oiz2ho">
                  {volume.sequenceIntro && <p className="text-ink font-semibold text-sm mb-2" data-id="element-394" data-mp="15stsidaq32s3">{volume.sequenceIntro}</p>}
                  <p className="text-ink font-bold text-sm bg-gold-soft border border-line rounded-lg px-3 py-2" data-id="element-395" data-mp="1fowvtmhb97gm">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-forest-50 border border-forest-100 border-l-4 border-l-forest rounded-xl p-4 mt-auto" data-id="element-396" data-mp="3hgjp5uoodeg9">
                <span className="text-forest font-bold block mb-1" data-id="element-397" data-mp="3mg4oi67rboti">RESULT</span>
                {volume.resultLead && <p className="text-graphite text-sm" data-id="element-398" data-mp="3eenmrpqoezqc">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-ink" data-id="element-399" data-mp="39h5bhsp6s8f6">{volume.resultQuote}</span>
                  </p>}
                <p className="text-graphite text-sm" data-id="element-400" data-mp="3jdi38l168c7a">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-forest" data-id="element-401" data-mp="17ltc4vt3krd">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}